<template>
  <div class="lde-help flex-vcenter">
    <img src="../../assets/media/illus/illus_elearning.svg" />
    <div>
      <h1 class="s3 light">
        {{ $t("general.lde-bonjour") }},
      </h1>
      <h2
        class="s3 bold"
        v-html="text"
      />
    </div>
    <ButtonClassic
      :balise-type="baliseType"
      :label="buttonLabel"
      variant="solid"
      color="secondary"
      icon="right"
      v-bind="attributes"
      @click="$emit('click')"
    >
      <template #right-icon>
        <UilCommentDots />
      </template>
    </ButtonClassic>
  </div>
</template>

<script>
import { defineComponent, inject } from "vue";
import ButtonClassic from "../../components/buttons/ButtonClassic.vue";

import { UilCommentDots } from "@lde/vue-unicons";

/**
 * Bouton permettant d'ouvrir le service LDE associé.
 */
export default defineComponent({
  name: "LdeHelp",
  components: {
    ButtonClassic,
    UilCommentDots,
  },
  props: {
    /**
     * Texte affiche sous le titre.
     */
    text: {
      type: String,
      default() { return inject("$t")("general.aide"); },
    },
    /**
     * Balise HTML du bouton dans le composant.
     */
    baliseType: {
      type: String,
      validator: (value) => ["button", "a", "router-link"].includes(value),
      default: "button",
    },
    /**
     * Label du bouton (optionnel, peut n'avoir que l'icône).
     */
    buttonLabel: {
      type: String,
      default: null,
    },
    /**
     * Lien du bouton.
     */
    extLink: {
      type: String,
      default: "mailto:accueil@lde.fr",
    },
    /**
     * Informations de la route si le bouton est une balise <router-link>.
     */
    routerLinkObj: {
      type: Object,
      default: null,
    },
  },
  computed: {
    attributes() {
      switch (this.baliseType) {
        case "a":
          return {
            href: this.extLink,
            target: "_blank",
            rel: "noreferrer noopener",
          };

        case "router-link":
          return {
            to: this.routerLinkObj,
          };

        default:
          return {};
      }
    },
  },
});
</script>

<style lang="scss">
@use "../../assets/styles/_variables.scss" as var;
@use "../../assets/styles/_effects.scss" as effect;

.lde-help {
  justify-content: space-between;
  padding: var.$space-tiny var.$space-medium;
  border: 1px solid var.$blue-16;
  border-radius: var.$border-radius-x-tiny;
  @include effect.whity-bumped;

  img,
  > div { margin-right: var.$space-tiny; }

  img {
    width: 15.5rem;
    height: 13.6rem;
  }

  h1 { color: var.$orange; }
}
</style>
